import type { ReactNode } from 'react';
import { MailRead } from '@/components/Icons/MailRead';
import { MailUnread } from '@/components/Icons/MailUnread';
import { MessageRecipientStatus } from '@/types/components';

const readIcon = (
  <MailRead className="size-4 shrink-0 text-subtle-foreground" />
);

export const recipientStatusIcon: Record<MessageRecipientStatus, ReactNode> = {
  [MessageRecipientStatus.Unread]: (
    <MailUnread className="size-4 shrink-0 text-primary" />
  ),
  [MessageRecipientStatus.Read]: readIcon,
  [MessageRecipientStatus.Replied]: readIcon,
  [MessageRecipientStatus.Forwarded]: readIcon,
};
